<div class="h-100 d-flex flex-column flex-fill overflow-hidden">
  <form [formGroup]="incentiveForm" (ngSubmit)="onIncentiveSubmit()">
    <div class="bg-white border p-3 rounded-2 mb-3">
      <div class="mb-3">
        <label class="form-label">Incentive</label>
        <currency-input-field
          formControlName="incentive"
          [currencySymbol]="currencySymbol()"
          placeholder="Enter"
          [min]="0"
          [disabled]="isCancelled() || !canWriteDeals()"
        ></currency-input-field>
      </div>
      @if (canWriteDeals()) {
        <button
          class="btn btn-primary w-100 justify-content-center btn-h35"
          type="submit"
          [disabled]="isCancelled()"
          appBtnLoader="deal-apply-incentive"
        >
          Apply Incentive
        </button>
      }
    </div>
  </form>
  <div class="bg-white border p-3 rounded-2">
    <form [formGroup]="discountForm" (ngSubmit)="onDiscountSubmit()">
      <div class="d-flex gap-2 flex-wrap mb-3">
        <div class="flex-fill">
          <label class="form-label">Discount Amount</label>
          <currency-input-field
            [type]="'number'"
            formControlName="discountAmount"
            [currencySymbol]="currencySymbol()"
            placeholder="Enter"
            [min]="0"
            [max]="addendumOption().amount"
            [disabled]="isCancelled() || !canWriteDeals()"
          ></currency-input-field>
          @if (
            discountForm.get('discountAmount')?.touched && discountForm.get('discountAmount')?.hasError('required')
          ) {
            <small class="text-danger">Discount Amount is required</small>
          }
          <small class="text-body-secondary">Percentage: {{ addendumOption().discountPercentage.toFixed(2) }}%</small>
        </div>
      </div>
      @if (canWriteDeals()) {
        <button
          class="btn btn-primary w-100 justify-content-center btn-h35"
          type="submit"
          [disabled]="isCancelled()"
          appBtnLoader="deal-apply-discount"
        >
          Apply Discount
        </button>
      }
    </form>
  </div>
</div>
